// The player's first interaction with the page (a tap, a click, a key). Browsers only play sound
// after one, so the big sound files (the theme tunes, the portals' music loop) aren't downloaded
// before it: on a slow connection they used to compete with the game's own first load. Hooks
// registered after the first interaction run at once.
let interacted = false;
const interactionHooks: Array<() => void> = [];
export const hasInteracted = () => interacted;
export const onFirstInteraction = (hook: () => void) => {
  if (interacted) {
    try {
      hook();
    } catch (e) {}
    return;
  }
  interactionHooks.push(hook);
};
export const markInteraction = () => {
  if (interacted) return;
  interacted = true;
  interactionHooks.splice(0).forEach((hook) => {
    try {
      hook();
    } catch (e) {}
  });
};
if (typeof document !== "undefined") {
  const opts = { passive: true, capture: true };
  // A click with no pointer events before it comes from assistive technology.
  ["pointerdown", "touchstart", "click", "keydown"].forEach((type) => document.addEventListener(type, markInteraction, opts));
}

// Tests only.
export const _resetInteractionForTests = () => {
  interacted = false;
  interactionHooks.splice(0);
};
